import {lazy, FC, Suspense, useEffect} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_heomoney/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_heomoney/assets/ts/_utils'
import {WithChildren} from '../../_heomoney/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {cargaDatosStore} from '../modules/remesas/components/stores/cargaDatosStore'

const PrivateRoutes = () => {
  const CatalogoPage = lazy(() => import('../modules/catalogo/CatalogoPage'))
  const RemesasPage = lazy(() => import('../modules/remesas/RemesasPage'))
  const TandasPage = lazy(() => import('../modules/tandas/TandasPage'))

  const HerramientasPage = lazy(() => import('../modules/herramientas/HerramientasPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))

  const updateMonedasCotizadorEnviar = cargaDatosStore(
    (state) => state.updateMonedasCotizadorEnviar
  )

  useEffect(() => {
    updateMonedasCotizadorEnviar()
  }, [])

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />

        <Route
          path='menu/remesas/*'
          element={
            <SuspensedView>
              <RemesasPage />
            </SuspensedView>
          }
        />

        <Route
          path='menu/catalogo/*'
          element={
            <SuspensedView>
              <CatalogoPage />
            </SuspensedView>
          }
        />

        <Route
          path='menu/tandas/*'
          element={
            <SuspensedView>
              <TandasPage />
            </SuspensedView>
          }
        />

        <Route
          path='herramientas/*'
          element={
            <SuspensedView>
              <HerramientasPage />
            </SuspensedView>
          }
        />

        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />

        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
